module.exports = {"id":"193337","name":"Joel Obi","rating":"74","photo":"./data/images/photos/2/193337.png","club":{"name":"Torino","logo":"./data/images/clubs/Torino.png"},"positions":["MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoelObi0.json
// module id = 2054
// module chunks = 0